import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InterviewStatusService {
  private baseUrl = `${environment.apiUrl}/vendor`;

  constructor(
    private http: HttpClient,
  ) {}

getVendorInterviewStatus(vendorId: number, month: number,year: number): Observable<Map<string, Object>> {
    const url = `${this.baseUrl}/interview-status`; 
    const params = { vendorId: vendorId.toString(), month: month.toString(), year: year.toString() }; 
    return this.http.get<Map<string, Object>>(url, { params }).pipe(
      catchError(() => {
        alert('Error fetching interview status. Please try again later.');
        return throwError(() => new Error('Failed to fetch interview status. Please try again later.'));
      })
    );
  }
}